import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-upload"
export default class extends Controller {
  preview(event) {
    const file = event.target.files[0]
    if (!file) return
    
    // File size validation
    if (file.size > 200 * 1024 * 1024) {
      alert("File size must be less than 200MB")
      event.target.value = ""
      return
    }
    
    // File type validation
    if (!file.type.startsWith('video/')) {
      alert("Please select a video file")
      event.target.value = ""
      return
    }
    
    // Show file info
    const fileInfo = document.createElement('div')
    fileInfo.className = 'mt-2 text-sm text-gray-600'
    fileInfo.innerHTML = `
      <p>Selected: ${file.name}</p>
      <p>Size: ${this.formatFileSize(file.size)}</p>
      <p>Type: ${file.type}</p>
    `
    
    // Remove existing file info
    const existing = event.target.parentNode.querySelector('.file-info')
    if (existing) existing.remove()
    
    fileInfo.classList.add('file-info')
    event.target.parentNode.appendChild(fileInfo)
  }
  
  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }
}